export default __webpack_public_path__ + "static/media/bancoob-logo.2360af3f.png";